import { Component, ChangeDetectionStrategy } from '@angular/core';

import { TranslocoModule } from '@jsverse/transloco';
import { PipesModule } from '@cbcore/pipes/pipes.module';
import { UnitsDistributionBase } from '../base/units-distribution.base';

@Component({
    selector: 'ud-wrc',
    templateUrl: './default/wrc/wrc.html',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [TranslocoModule, PipesModule]
})
export class WrcComponent extends UnitsDistributionBase {
  // Used for WRC_WINNER
  override getUnits(distribution: any): number {
    return super.getUnits(distribution);
  }
}